import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Enhanced global error logging for production debugging
window.addEventListener('error', (event) => {
  const errorInfo = {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href
  };
  
  console.error('[Global Error]:', event.error, errorInfo);
  
  // Store error for debugging
  try {
    const globalErrors = JSON.parse(localStorage.getItem('global_errors') || '[]');
    globalErrors.push(errorInfo);
    if (globalErrors.length > 20) globalErrors.shift(); // Keep last 20 errors
    localStorage.setItem('global_errors', JSON.stringify(globalErrors));
  } catch (e) {
    console.warn('Could not store error in localStorage:', e);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const rejectionInfo = {
    reason: event.reason?.message || event.reason,
    stack: event.reason?.stack,
    timestamp: new Date().toISOString(),
    url: window.location.href
  };
  
  console.error('[Unhandled Promise Rejection]:', rejectionInfo);
  
  // Store rejection for debugging
  try {
    const rejections = JSON.parse(localStorage.getItem('promise_rejections') || '[]');
    rejections.push(rejectionInfo);
    if (rejections.length > 20) rejections.shift();
    localStorage.setItem('promise_rejections', JSON.stringify(rejections));
  } catch (e) {
    console.warn('Could not store rejection in localStorage:', e);
  }
});

// Add recovery mechanism for DOM errors and chunk loading failures
const originalCreateElement = document.createElement;
document.createElement = function(tagName, options) {
  try {
    return originalCreateElement.call(this, tagName, options);
  } catch (error) {
    console.error('[DOM CreateElement Error]:', error);
    // Return a safe fallback element
    return originalCreateElement.call(this, 'div');
  }
};

// Handle chunk loading errors
window.addEventListener('error', (event) => {
  if (event.message?.includes('Loading chunk') || event.message?.includes('ChunkLoadError')) {
    console.warn('[Chunk Load Error] Reloading page:', event.message);
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
